// src/brokerageadmin/QuoteyDashboard/sortingUtils.js
const getNestedValue = (obj, path) => {
    if (!path) return undefined;
    return path.split('.').reduce((o, k) => (o && o[k] !== undefined) ? o[k] : undefined, obj);
};

export const sortData = (data, sortConfig) => {
  if (!data || !sortConfig || !sortConfig.key) {
    return data || [];
  }
  const sorted = [...data];
  sorted.sort((a, b) => {
    const aValue = getNestedValue(a, sortConfig.key);
    const bValue = getNestedValue(b, sortConfig.key);
    let comparison = 0;
    if (aValue == null && bValue == null) comparison = 0;
    else if (aValue == null) comparison = 1;
    else if (bValue == null) comparison = -1;
    else if (typeof aValue === 'boolean' && typeof bValue === 'boolean') {
        comparison = aValue === bValue ? 0 : (aValue ? -1 : 1);
    }
    else if (!isNaN(new Date(aValue)) && !isNaN(new Date(bValue)) && typeof aValue !== 'number' && typeof bValue !== 'number') {
         const dateA = new Date(aValue).getTime();
         const dateB = new Date(bValue).getTime();
         comparison = dateA - dateB;
    }
    else if (typeof aValue === 'number' && typeof bValue === 'number') comparison = aValue - bValue;
    else if (typeof aValue === 'string' && typeof bValue === 'string') comparison = aValue.toLowerCase().localeCompare(bValue.toLowerCase());
    else if (aValue < bValue) comparison = -1;
    else if (aValue > bValue) comparison = 1;
    return sortConfig.direction === 'descending' ? comparison * -1 : comparison;
  });
  return sorted;
};

export const getSortIndicator = (columnKey, sortConfig) => {
  if (!sortConfig || sortConfig.key !== columnKey) return <span className="sort-indicator"></span>;
  return sortConfig.direction === 'ascending'
    ? <span className="sort-indicator">▲</span>
    : <span className="sort-indicator">▼</span>;
};